// extracted by mini-css-extract-plugin
module.exports = {"block":"i_TV","content":"i_TW","heading":"i_TX","answers":"i_TY","answer":"i_TZ","unanswered":"i_Ta","answered":"i_Tb","selected":"i_Tc","label":"i_Td"};